module.exports = __webpack_public_path__ + "img/Benevol.bd4c27ab.jpg";